import { useState, useMemo, useRef } from 'react';
import CardHeaderSlotContext from '../../StateManagment/CardHeaderSlot';
import { DashboardCardFooterContext } from '../dashboard/DashboardCard';
import CopyCardButton from '../dashboard/CopyCardButton';

/**
 * Analytics-page card frame: the `.new-dashboard-card` shell with the same
 * bottom bar as DashboardCard (info slot, option icons, counter), so analytics
 * and dashboard cards share the same slot mechanism. Analytics cards have no
 * drag handle or delete icon.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children - The card body.
 */
const AnalysisCardFrame = ({ children }) => {
    const [footerEl, setFooterEl] = useState(null);
    // De kaartinhoud, voor 'Kopiëren als afbeelding'.
    const contentRef = useRef(null);
    const [counterSlot, setCounterSlot] = useState(null);
    const [infoSlot, setInfoSlot] = useState(null);
    const [filterSlot, setFilterSlot] = useState(null);
    const headerSlots = useMemo(
        () => ({ counterSlot, infoSlot, filterSlot }),
        [counterSlot, infoSlot, filterSlot]
    );

    return (
        <div className="new-dashboard-card analysis-card">
            <CardHeaderSlotContext.Provider value={headerSlots}>
                <DashboardCardFooterContext.Provider value={footerEl}>
                    <div className="new-dashboard-card-content" ref={contentRef}>
                        {children}
                    </div>
                </DashboardCardFooterContext.Provider>
            </CardHeaderSlotContext.Provider>
            <div className="new-dashboard-card-footer">
                <span className="new-dashboard-card-footer-info-slot" ref={setInfoSlot} />
                {/* Hidden via CSS when the info slot is empty */}
                <span className="new-dashboard-card-footer-divider" />
                <span className="new-dashboard-card-footer-filter-slot" ref={setFilterSlot} />
                {/* Hidden via CSS when the filter slot is empty */}
                <span className="new-dashboard-card-footer-divider" />
                <CopyCardButton targetRef={contentRef} />
                <span className="new-dashboard-card-footer-options" ref={setFooterEl} />
                <span className="new-dashboard-card-footer-counter-slot" ref={setCounterSlot} />
            </div>
        </div>
    );
};

export default AnalysisCardFrame;
